/*
 * Desktop - Side Cart - Visual Fixes  --  variant: Reduced Spacing And Trust Pilot Above Badge Gray Background
 * Moonshot experiment id: 43092708   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-12-08
 * Audience: DESKTOP   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Fix 2026-09-10: the Trustpilot selector was a bare ".trustpilot-widget". Once sc_d_trustpilot_widget strips that
 *         class from the cart badge, the bare selector matched the header announcement bar widget and moved it into
 *         the cart, leaving the desktop top bar empty (2px black line). Selector is now scoped to .bag-container and
 *         also matches the rebuilt .msai-tp-custom badge.
 * Enabled by theme setting: mgexp_sc_d_visual_fixes
 */
MGExp.run('sc_d_visual_fixes', { name: "Desktop - Side Cart - Visual Fixes / Reduced Spacing And Trust Pilot Above Badge Gray Background", platform: 'desktop', target: 'side_cart' }, function () {
  !(function () {
    let t = [],
      n = [];
    !(async function (a, i, o, e, d) {
      let s = {
        multi_target_selectors: t,
        page_identifier_selector: "div.mini-cart-wrap",
        exclude_from_timeout: n,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(a, i, o, e, d, s);
    })(
      [
        ".bag-items.overflow-y-auto.flex-grow",
        "div.bag-summary",
        ".bag-container .trustpilot-widget:not(.announcement-bar), .bag-container .msai-tp-custom",
        ".mc-icons",
      ],
      ".msai-side-cart-spacing-adjusted",
      function (t, n) {
        const [a, i, o, e] = n;
        (a.classList.add("msai-spacing-adjusted"),
          i.classList.add("msai-side-cart-spacing-adjusted"),
          e.insertAdjacentElement("beforebegin", o));
      },
      "\n  /* Reduce padding on bag items container */\n  .bag-items.overflow-y-auto.flex-grow {\n    padding-top: 20px !important;\n  }\n  \n  /* Reduce padding on bag summary section */\n  div.bag-summary {\n    padding-top: 20px !important;\n  }\n  \n  /* Reduce padding on checkout button */\n  button.bag-checkout {\n    padding-top: 15px !important;\n    padding-bottom: 15px !important;\n  }\n  \n  /* Align subtotal amount to the right */\n  span[data-cart-total] {\n    text-align: right;\n    display: block;\n    width: 100%;\n  }\n\n  .mini-cart-wrap .bag-close {\n    top: 30px !important;\n  }\n  \n  .bag-container .trustpilot-widget {\n    margin-bottom: 20px !important;\n    min-height: 140px !important;\n    background: #F6F6F6;\n    padding: 22px 20px 0;\n  }\n",
    );
  })();
});
